module.exports = __webpack_public_path__ + "media/images/home-banners/nathan-dumlao-334346-unsplash-15a7779f9613d628f8815e90beb64fe6.jpg";